module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations-large@3x.94db9d3f.png";